import { useEffect, useState } from "react"
import url from "../api/url"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

export default function useNotificaciones() {

    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [cargando, setCargando] = useState(false)
    const [cargandoNotificaciones, setCargandoNotificaciones] = useState(false)
    const [leyendoTodas, setLeyendoTodas] = useState(false)
    const [notificaciones, setNotificaciones] = useState([])
    const { URL: URL_MIO } = url()
    const [idEmpleadoNotificacion, setIdEmpleadoNotificacion] = useState(0)

    const notificacionesIndividuales = useEmpleadoStore(state => state.notificacionesIndividuales)
    const setNotificacionesIndividuales = useEmpleadoStore(state => state.setNotificacionesIndividuales)
    // const [notificacionesIndividuales, setNotificacionesIndividuales] = useState([])
    const [nombreNotificacion, setNombreNotificacion] = useState("")
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => setShow(true);

    const limpiarNotificaciones = () => {
        setNotificacionesIndividuales([])
    }


    function listar_notificaciones() {

        if (!objLogueado.email) {
            return
        }

        setCargando(true)

        var body = new FormData()
        body.append('funcion', 'listar_notificaciones')

        fetch( URL_MIO, {
            method: 'post',
            body: body
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            // console.log(datos);
            setNotificaciones(datos)
        })
        .catch(err => {
            alert('Hay problemas al traer las notificaciones.')
        })
        .finally(() => setCargando(false))
    }


    const getNotificaciones = () => {

        setCargandoNotificaciones(true)
        const body = {
            funcion: 'listar_notificaciones_por_empleado',
            id: idEmpleadoNotificacion
        }


        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify(body)
        })
        .then(respuesta => respuesta.json())
        .then( setNotificacionesIndividuales )
        .catch(err => {
            // console.log(err);
            // alert('Hay problemas al marcar como leída.')
        })
        .finally(() => setCargandoNotificaciones(false))

    }


    const leerTodas = () => {

        setLeyendoTodas(true)
        const body = {
            funcion: 'leer_todas_notificaciones',
            id: notificacionesIndividuales
        }

        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify(body)
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            // eslint-disable-next-line
            if (datos.tipo == 1) {
                actualizarTodas()
            } else {
                // nada
            }

        })
        .catch(err => {
            // console.log(err);
            // alert('Hay problemas al marcar como leída.')
        })
        .finally(() => setLeyendoTodas(false))

    }



    const actualizarTodas = () => {
        var not = notificacionesIndividuales.map( n => {
            n.leida = 1
            return n
        })
        // console.log(not);

        setNotificacionesIndividuales(not)
        // handleClose()
    }


    useEffect(() => {

        listar_notificaciones()
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        if (idEmpleadoNotificacion) {
            getNotificaciones()
            // eslint-disable-next-line
            let nombre_empleado = notificaciones.find(e => e.pk_empleado == idEmpleadoNotificacion).nombre_empleado
            setNombreNotificacion( nombre_empleado )
        }
        // eslint-disable-next-line
    }, [ idEmpleadoNotificacion ])


    return {
        notificaciones, show, handleClose, handleShow,
        setIdEmpleadoNotificacion, notificacionesIndividuales, nombreNotificacion,
        limpiarNotificaciones, leerTodas, leyendoTodas, cargando, cargandoNotificaciones
    }
}

